<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- <p-button (onClick)="sidebarVisible = true" icon="ph ph-shopping-cart" /> -->
<div>
  <i
    class="ph ph-shopping-cart mx-4 p-text-primary cursor-pointer"
    pBadge
    style="font-size: 2rem"
    [value]="totalElements"
    (click)="sidebarVisible = true"
    aria-hidden="true"></i>
</div>

<p-sidebar
  [(visible)]="sidebarVisible"
  position="right"
  [style]="{ width: '100%', maxWidth: '500px' }">
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Tu pedido</span>
  </ng-template>

  <div id="cart">
    <div
      *ngFor="let product of cartService.cart; let index = index"
      class="cart-item"
      [ngClass]="{
        custom: !lodash.isEqual(product.ingredients, product.finalIngredients)
      }">
      <div class="image">
        <img src="{{ product.image_url }}" alt="{{ product.name }}" />
      </div>
      <div class="data">
        <div>
          <b>{{ product.name }}</b>
        </div>
        <div>{{ (product.price + product.extraPrice || 0).toFixed(2) }} €</div>
        <div
          id="show-{{ index }}"
          class="text-sm cursor-pointer show-ingredients"
          tooltipPosition="top"
          [pTooltip]="tooltipContent"
          tooltipEvent="click"
          (click)="clickTooltip(index)"
          [life]="4000">
          Ver ingredientes
        </div>

        <ng-template #tooltipContent>
          <div class="">
            Salsa de tomate, muzzarella
            <ng-container *ngFor="let ingredient of product.finalIngredients">
              , {{ ingredient | ingredientName }}
            </ng-container>
          </div>
        </ng-template>
      </div>

      <div class="actions hidden sm:flex">
        <app-quantity-counter
          [initialQuantity]="product.quantity"
          [min]="1"
          (newQuantity)="changeQuantity(index, $event)"></app-quantity-counter>
        <p-button
          icon="ph ph-trash"
          label=""
          severity="danger"
          styleClass="w-7rem"
          (click)="removeProduct(index)" />
      </div>

      <div class="actions-mobile flex sm:hidden">
        <app-quantity-counter
          [initialQuantity]="product.quantity"
          [min]="1"
          (newQuantity)="changeQuantity(index, $event)"></app-quantity-counter>
        <p-button
          icon="ph ph-trash"
          label=""
          severity="danger"
          styleClass="w-7rem"
          (click)="removeProduct(index)" />
      </div>
    </div>

    <div
      *ngIf="cartService.cart.length <= 0"
      class="cart-item justify-content-center">
      <span>Todavía no has seleccionado ningún artículo.</span>
    </div>

    <div>
      <div
        class="flex justify-content-between border-bottom-1 border-gray-300 pb-3 mt-4">
        <span class="font-bold">Subtotal </span>
        <span>{{ subtotal.toFixed(2) }} €</span>
      </div>

      <div
        class="flex justify-content-between border-bottom-1 border-gray-300 pb-3 mt-4">
        <span class="font-bold">Entrega domicilio</span>
        <span>{{ (0).toFixed(2) }} €</span>
      </div>

      <div class="flex justify-content-between pb-3 mt-4">
        <span class="font-bold">Total </span>
        <span class="text-2xl">{{ subtotal.toFixed(2) }} €</span>
      </div>
    </div>

    <div class="flex gap-4 mt-4 justify-content-between flex-column">
      <!-- icon="ph ph-plus" -->
      <p-button
        label="Datos de entrega"
        severity="primary"
        styleClass="w-full p-3 border-round uppercase"
        id="send"
        [disabled]="cartService.cart.length <= 0"
        [routerLink]="['/pedido', {}]" />

      <!-- icon="ph ph-trash" -->
      <!-- <button pButton class="w-full p-3 flex justify-content-center uppercase">
        <span class="ph ph-plus pr-2"></span>Realizar pedido
      </button> -->
      <p-button
        id="cart-empty"
        label=" Vaciar carrito"
        severity="danger"
        styleClass="w-full p-3"
        (click)="emptyCart()"
        [disabled]="cartService.cart.length <= 0" />
    </div>
  </div>
</p-sidebar>
